<template>
    <v-dialog v-model="showDlg" :max-width="maxWidth" persistent>
      <v-card>
        <v-card-title class="text-body-1">
          <v-row>
            <v-col cols="1" v-if="icon">
              <v-icon class="mr-3" :color="color">{{ icon }}</v-icon>
            </v-col>
            <v-col
              :cols="icon ? 11 : 12"
              class="d-flex justify-center text-center fMontserrat"
            >
              {{ title }}
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text v-if="message" class="text-subtitle-2">
          <div class="text-center fMontserrat">
            {{ message }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-row class="d-flex justify-center">
            <v-col cols="5" v-if="showNoBtn">
              <v-btn
                :color="btnNOColor"
                text
                @click.stop.prevent="clickNO()"
                class="fMontserrat"
                >{{ btnNOOKMsg }}</v-btn
              >
            </v-col>
            <v-col :cols="showNoBtn ? '5' : '4'" align-self="center">
              <v-btn
                :color="btnOKColor"
                text
                @click.stop.prevent="clickOK()"
                class="fMontserrat"
                >{{ btnOKMsg }}</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    name: "indoMsgBox",
    data() {
      return {
        showDlg: false,
        color: null,
        icon: null,
        title: null,
        message: null,
        btnOKColor: null,
        btnNOColor: null,
        maxWidth: "450px",
        resolve: null,
        reject: null,
        showNoBtn: false,
        btnOKMsg: "",
        btnNOOKMsg: "",
      };
    },
    methods: {
      confirm(data) {
        if (!data) return;
        this.title = data.title || "";
        this.message = data.message;
        this.color = data.color || "success";
        this.btnOKColor = data.btnOKColor || "primary";
        this.btnNOColor = data.btnNOColor || "red";
        this.icon = data.icon;
        this.maxWidth = data.maxWidth || "450px";
        this.showNoBtn = data.showNoBtn;
        this.showDlg = true;
        this.btnOKMsg = data.btnOKMsg || "ACEPTAR";
        this.btnNOOKMsg = data.btnNOOKMsg || "CANCELAR";
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      },
      clickOK() {
        this.showDlg = false;
        this.resolve(true);
      },
      clickNO() {
        this.showDlg = false;
        this.resolve(false);
      },
    },
  };
  </script>
  
  <style scoped>
  .fMontserrat {
    font-family: "Montserrat", sans-serif !important;
  }
  </style>
  